import { useCallback } from 'react';
import { Queue } from '@shared/util/hooks/useQueue';
import { uuid } from '@shared/util/uuid';
import { ToastProps } from './Toast';

export type ToastCreator = (props: ToastProps) => Promise<void>;

export interface QueuedToast extends ToastProps {
  id: string;
  remove: () => void;
}

export function useToastCreator({ append, prepend, remove }: Queue<QueuedToast>): ToastCreator {
  return useCallback(
    async (toastProps: ToastProps) => {
      return new Promise(resolve => {
        const ToastId = uuid();
        const toast: QueuedToast = {
          ...toastProps,
          position: getToastPosition(toastProps),
          id: ToastId,
          remove: () => {
            resolve();
            remove(toast);
          },
        };
        if (toastProps.prioritize) {
          prepend(toast);
        } else {
          append(toast);
        }
      });
    },
    [append, prepend, remove],
  );
}

function getToastPosition({ style, position }: ToastProps) {
  if (position) {
    return position;
  }
  switch (style) {
    case 'warning':
    case 'important':
      return 'top';
    case 'confirmation':
    case 'info':
    default:
      return 'bottom';
  }
}
